export * from './request'

export const Errno = {
  onLogin: 1002,
  RequestSetTimeOut: 999999, // 接口超时
  GoodsNotExist: 13004, // 商品不存在
  GoodsCanNotBuy: 13014, // 没有购买权限
  OtherError: -1, // 其他异常
}

export const dealPageErrno = (error = {}) => {
  // 内置请求需要.extra，trade-sdk中不需要extra
  const err = error?.extra || error || {}
  if (err.errmsg?.indexOf?.('request:fail Error: timeout of') !== -1) {
    return Errno.RequestSetTimeOut
  }
  return err.errno || Errno.OtherError
}
